import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, cloneDeep } from 'lodash';
import { round } from 'mathjs';

import '../scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20, LightIcon } from '@styled/icon';
import { locateValue, newRate } from '@tool/index';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import moFreshYear from './store';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import Chart from './chart';
import Table from './table';

interface IProps {}
interface IState {}

const SalaryIndustryPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const {
    xData, yData, labels,
    tableHead, tableList,
  } = moFreshYear;
  const { isMock } = moIndex;

  // 第二个参数 - 保留几位小数
  const clacRate = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value === 0) return 0;
    return round(value * 100, digit);
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="up-rate_101101">
      {!isEmpty(xData) ? (
        <section className="box-101101">
          <section className={[
            'box-13', !isMock ? '' : 'mock-100',
          ].join(' ')}
          style={{ overflowY: 'auto' }}>
            <section className="chart-title_03">
              {labels.map((item: any, idx: number) => (
                <p key={idx} className="line-03">
                  <strong>{locateValue(item.value)}</strong>
                  <span>{item?.text}</span>
                </p>
              ))}
            </section>
            <section style={{
              width: '100%',
              overflowY: 'auto',
            }}>
              <Chart height={300} xData={xData.slice(0, 5)} yData={yData} />
            </section>
          </section>
        </section>
      ) : (<Empty padding="50px 0" />)}
    </section>
  );
};

export default observer(SalaryIndustryPDF);
